<script setup lang="ts">
interface BlockContainerProps {
  fullWidth?: boolean;
  removePaddingY?: boolean;
}

withDefaults(defineProps<BlockContainerProps>(), {
  fullWidth: false,
  removePaddingY: false,
  fullCenterWidth: false,
});
</script>
<template>
  <section :class="[!removePaddingY ? 'py-8 mx-auto' : '', !fullWidth ? 'px-6 lg:px-16 lg:py-24 max-w-7xl' : '']">
    <slot />
  </section>
</template>
